import { SESSION_KEYS } from '@/constants.js';

export default {
  setCompanySlug(state, slug) {
    state.slug = slug;
  },

  setBenefits(state, benefits) {
    state.benefits = benefits;
  },

  setCompanySettings(state, settings) {
    state.slug = settings.slug;
    state.jobportalOnly = settings.jobportalOnly;
    state.showExternalAdvert = settings.showExternalAdvert;
    state.customCookieBanner = settings.customCookieBanner;
    state.useGoogleAnalytics = settings.useGoogleAnalytics;
    state.useMatomo = settings.useMatomo;
    state.useUsercentrics = settings.useUsercentrics;
    state.googleAnalyticsId = settings.googleAnalyticsIdentifier;
    state.matomoUrl = settings.matomoUrl;
    state.matomoSiteId = settings.matomoSiteId;
    state.usercentricsId = settings.usercentricsId;
    state.customAnalyticsScript = settings.customAnalyticsScript;
    state.customAnalyticsAcceptScript = settings.customAnalyticsAcceptScript;
    state.customAnalyticsRejectScript = settings.customAnalyticsRejectScript;
    state.footerContent = settings.footerContent;
    state.jobsDefaultTopContent = settings.jobsDefaultTopContent;
    state.jobsDefaultBottomContent = settings.jobsDefaultBottomContent;
    state.showAvailableFiltersOnly = settings.showAvailableFiltersOnly;
    state.acceptTalentpoolInApplicationProcess =
      settings.acceptTalentpoolInApplicationProcess;
    state.candidateAccountMode = settings.candidateAccountMode || 0;
    state.forceNoIndex = settings.forceNoIndex;
    state.homeSearchField = settings.homeSearchField;
    state.homeJobsButton = settings.homeJobsButton;
    state.heroVideoUrl = settings.defaultHeroVideo;
    state.hasLinkToJobportal = settings.hasLinkToJobportal;
    state.customLinkToJobportal = settings.customLinkToJobportal;
    state.hasCustomSocialMediaIcons = settings.hasCustomSocialMediaIcons;
    state.customChildCompanyLogos = settings.customChildCompanyLogos;
    state.customChildCompanyLogoAltText =
      settings.customChildCompanyLogoAltText;
    state.customChildCompanyLogoUrl = settings.customChildCompanyLogoUrl;
    state.additionalFooterLinks = settings.additionalFooterLinks;
    state.customScripts = settings.customScripts;
    state.usePreviousJobsListForm = settings.previousJobsListForm;
    state.showBlacklistedJoboffers = settings.showBlacklistedJoboffers;
    state.disableQuestionsForInternalApplications =
      settings.disableQuestionsForInternalApplications;
    state.recommendedChannel = settings.recommendedChannel;
    state.recommendedChannelMessage = settings.recommendedChannelLabel ?? [];
    state.benefitsColor = settings.themeSettings.benefitsColor;

    state.jobsLayout = settings.jobsLayout;
    state.jobsLayoutToggle = settings.jobsLayoutToggle;

    if (settings.baseUrl) {
      state.baseUrl = settings.baseUrl;
    }

    if (settings.jobportalBaseUrl) {
      state.jobportalBaseUrl = settings.jobportalBaseUrl;
    }

    if (settings.benefits) {
      state.benefits = settings.benefits;
    }

    if (settings.availableFilters) {
      state.filters = settings.availableFilters;
    }

    if (settings.availableJobalertFilters) {
      state.jobalertFilters = settings.availableJobalertFilters;
    }

    if (settings.availableDataFields) {
      state.jobDataFields = settings.availableDataFields;
    }

    if (settings.pageTitle) {
      state.pageTitle = settings.pageTitle;
    }

    if (settings.pageDescription) {
      state.pageDescription = settings.pageDescription;
    }

    if (settings.languages) {
      state.languages = settings.languages;
    }

    if (settings.customImprintUrl) {
      state.customImprintUrl = settings.customImprintUrl;
    }

    if (settings.customDataPrivacyUrl) {
      state.customDataPrivacyUrl = settings.customDataPrivacyUrl;
    }

    if (settings.defaultClaim) {
      state.defaultClaim = settings.defaultClaim;
    }

    if (settings.jobsContentPosition && settings.jobsContentPosition !== '') {
      state.jobsContentPosition = settings.jobsContentPosition;
    }

    if (
      settings.jobsDefaultContentPosition &&
      settings.jobsDefaultContentPosition !== ''
    ) {
      state.jobsDefaultContentPosition = settings.jobsDefaultContentPosition;
    }

    if (settings.companyApiUrls) {
      state.companyApiUrls = settings.companyApiUrls;
    }
  },

  setCurrentCompanyId(state, companyId) {
    state.currentCompanyId = companyId;
  },

  setReferrer(state, referrer) {
    state.referrer = referrer;
  },

  setInternal(state, token) {
    state.isInternal = true;
    localStorage.setItem(SESSION_KEYS.isInternal, 'true');

    state.internalToken = token;
    localStorage.setItem(SESSION_KEYS.internalToken, token);
  },

  setExternal(state) {
    state.isInternal = false;
    localStorage.setItem(SESSION_KEYS.isInternal, 'false');

    state.internalToken = '';
    localStorage.setItem(SESSION_KEYS.internalToken, '');
  },

  setJobsLayout(state, layout) {
    state.jobsLayout = layout;
  }
};
